import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, tap } from 'rxjs';
import { HomeChargerStateService } from '../shared/services/home-charger-state.service';

@Injectable()
export class WithCredentialsInterceptor implements HttpInterceptor {
  constructor(private stateService: HomeChargerStateService) {}
  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (this.requestShouldBeHandled(request)) {
      return next
        .handle(
          request.clone({
            withCredentials: true,
          })
        )
        .pipe(
          tap({
            next: () => {
              this.redirectToCheckConnectionStep(false);
            },
            error: (error: HttpErrorResponse) => {
              if (error.status === 401) {
                this.redirectToCheckConnectionStep(true);
              }
            },
          })
        );
    }
    return next.handle(request);
  }

  private requestShouldBeHandled(request: HttpRequest<any>): boolean {
    return request.url.includes('vaylens.com');
  }

  private redirectToCheckConnectionStep(redirect: boolean) {
    if (redirect) {
      this.stateService.connectionAttempt.next(undefined);
      this.stateService.nextStepButtonDisabled.next(false);
      this.stateService.templateCheckError.next(false);
    }
    this.stateService.redirectToCheckConnectionStep.next(redirect);
  }
}
